// src/components/dynamic-map/dynamic-map.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment DynamicMapFragment on EGDSBasicMap {\n    label\n    initialViewport\n    center {\n      latitude\n      longitude\n    }\n    zoom\n    bounds {\n      northeast {\n        latitude\n        longitude\n      }\n      southwest {\n        latitude\n        longitude\n      }\n    }\n    computedBoundsOptions {\n      coordinates {\n        latitude\n        longitude\n      }\n      gaiaId\n      lowerQuantile\n      upperQuantile\n      marginMultiplier\n      minMargin\n      minimumPins\n      interpolationRatio\n    }\n    config {\n      ... on EGDSDynamicMapConfig {\n        accessToken\n        egdsMapProvider\n        externalConfigEndpoint {\n          value\n        }\n        mapId\n      }\n    }\n    markers {\n      ... on EGDSMapFeature {\n        id\n        description\n        markerPosition {\n          latitude\n          longitude\n        }\n        type\n        markerStatus\n        qualifiers\n        text\n        clientSideAnalytics {\n          linkName\n          referrerId\n        }\n        onSelectAccessibilityMessage\n        onEnterAccessibilityMessage\n      }\n    }\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment MapCardContentFragment on EGDSImageCard {\n    id\n    title\n    subTitle\n    description\n    image {\n      aspectRatio\n      description\n      thumbnailClickAnalytics {\n        eventType\n        linkName\n        referrerId\n        uisPrimeMessages {\n          messageContent\n          schemaName\n        }\n      }\n      url\n    }\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
import React from "react";
import { gql } from "@apollo/client";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSPageLoader } from "@egds/react-core/loader";
import { EGDSEGMaps, EGDSEGMapsQualifier as EGDSEGMapsQualifier2, EGDSEGMapsType } from "@egds/react-maps";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useGoogleMapsSdkVersion } from "@shared-ui/retail-map-google-maps-sdk-version-provider";
// src/utils/event-utils.ts
import { EGDSEGMapsQualifier } from "@egds/react-maps";
var getVisibleFeatureCount = function (mapObj, featureFilter) {
  var combinedFilter = function (feature) {
    return featureFilter(feature) && feature.visible;
  };
  return mapObj.listFeatures(combinedFilter, mapObj.getBounds()).length;
};
var filterTransport = function (feature) {
  var _feature_qualifiers, _feature_qualifiers1, _feature_qualifiers2, _feature_qualifiers3, _feature_qualifiers4;
  return ((_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(EGDSEGMapsQualifier.AIRPORT)) || ((_feature_qualifiers1 = feature.qualifiers) === null || _feature_qualifiers1 === void 0 ? void 0 : _feature_qualifiers1.includes(EGDSEGMapsQualifier.TRANSPORTATION)) || ((_feature_qualifiers2 = feature.qualifiers) === null || _feature_qualifiers2 === void 0 ? void 0 : _feature_qualifiers2.includes(EGDSEGMapsQualifier.BUS_STATION)) || ((_feature_qualifiers3 = feature.qualifiers) === null || _feature_qualifiers3 === void 0 ? void 0 : _feature_qualifiers3.includes(EGDSEGMapsQualifier.TRANSIT)) || ((_feature_qualifiers4 = feature.qualifiers) === null || _feature_qualifiers4 === void 0 ? void 0 : _feature_qualifiers4.includes(EGDSEGMapsQualifier.METRO_STATION));
};
var getContentPresentedOptions = function (mapObj, origin) {
  var enabledTilesets = mapObj === null || mapObj === void 0 ? void 0 : mapObj.getActiveTilesets();
  var clusterCount = getVisibleFeatureCount(mapObj, function (feature) {
    return feature.type === "cluster";
  });
  var propertyCount = getVisibleFeatureCount(mapObj, function (feature) {
    return feature.type === "property" || feature.type === "product";
  });
  var transportationCount = getVisibleFeatureCount(mapObj, filterTransport);
  var poiCount = getVisibleFeatureCount(mapObj, function (feature) {
    var _feature_qualifiers;
    return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(EGDSEGMapsQualifier.POINT_OF_INTEREST);
  });
  var groceryCount = getVisibleFeatureCount(mapObj, function (feature) {
    var _feature_qualifiers;
    return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(EGDSEGMapsQualifier.GROCERY);
  });
  var restaurantCount = getVisibleFeatureCount(mapObj, function (feature) {
    var _feature_qualifiers;
    return (_feature_qualifiers = feature.qualifiers) === null || _feature_qualifiers === void 0 ? void 0 : _feature_qualifiers.includes(EGDSEGMapsQualifier.RESTAURANT);
  });
  return {
    transportationCount: transportationCount,
    groceryCount: groceryCount,
    restaurantCount: restaurantCount,
    placesOfInterestCount: poiCount,
    tileSets: enabledTilesets,
    productClusterCount: clusterCount,
    propertyCount: propertyCount,
    origin: origin
  };
};
var CONTENT_PRESENTED_DELAY = 200;
// src/utils/geometry-utils.ts
var roundCoordinate = function (num) {
  var ONE_MILLION = 1e6;
  return Math.round((num + Number.EPSILON) * ONE_MILLION) / ONE_MILLION;
};
var boundingBoxToString = function (southwest, northeast) {
  var roundedSouthwest = southwest.map(roundCoordinate);
  var roundedNortheast = northeast.map(roundCoordinate);
  return "".concat(roundedSouthwest, ", ").concat(roundedNortheast);
};
var egBoundsToString = function (bounds) {
  var _bounds_sw_, _bounds_sw_1, _bounds_ne_, _bounds_ne_1;
  var boundingBox = [[(_bounds_sw_ = bounds.sw[0]) !== null && _bounds_sw_ !== void 0 ? _bounds_sw_ : 0, (_bounds_sw_1 = bounds.sw[1]) !== null && _bounds_sw_1 !== void 0 ? _bounds_sw_1 : 0], [(_bounds_ne_ = bounds.ne[0]) !== null && _bounds_ne_ !== void 0 ? _bounds_ne_ : 0, (_bounds_ne_1 = bounds.ne[1]) !== null && _bounds_ne_1 !== void 0 ? _bounds_ne_1 : 0]];
  var emptyNumberList = [];
  var _boundingBox_, _boundingBox_1;
  return boundingBoxToString((_boundingBox_ = boundingBox[0]) !== null && _boundingBox_ !== void 0 ? _boundingBox_ : emptyNumberList, (_boundingBox_1 = boundingBox[1]) !== null && _boundingBox_1 !== void 0 ? _boundingBox_1 : emptyNumberList);
};
// src/utils/marker-utils.tsx
var convertMarkers = function (mapMarkers) {
  return (mapMarkers !== null && mapMarkers !== void 0 ? mapMarkers : []).map(function (marker, index) {
    var type = (marker.type || "place").toString().toLowerCase();
    var status = (marker.markerStatus || "unknown").toString().toLowerCase();
    var ariaLabels;
    if (marker.onSelectAccessibilityMessage || marker.onEnterAccessibilityMessage) {
      ariaLabels = {
        default: marker.onEnterAccessibilityMessage || "",
        onSelect: marker.onSelectAccessibilityMessage || ""
      };
    }
    var _marker_text;
    return {
      id: marker.id || "index-".concat(index),
      name: (_marker_text = marker.text) !== null && _marker_text !== void 0 ? _marker_text : void 0,
      lat: marker.markerPosition.latitude,
      lng: marker.markerPosition.longitude,
      type: type,
      status: status,
      qualifiers: _to_consumable_array(marker.qualifiers),
      text: type === "place" ? marker.text || void 0 : void 0,
      price: type === "property" || type === "product" ? marker.text : void 0,
      ariaLabels: ariaLabels
    };
  });
};
// src/hooks/use-eg-maps-clickstream/use-eg-map-clickstream.tsx
import { useClickTracker, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var INTERACTION = "Interaction";
var IMPRESSION = "Impression";
var EventVersion = /* @__PURE__ */function (EventVersion2) {
  EventVersion2["ONE_ZERO_ZERO"] = "1.0.0";
  EventVersion2["ONE_ZERO_ONE"] = "1.0.1";
  EventVersion2["TWO_THREE_ZERO"] = "2.3.0";
  EventVersion2["TWO_FOUR_ZERO"] = "2.4.0";
  EventVersion2["TWO_SIX_ZERO"] = "2.6.0";
  EventVersion2["THREE_TWO_ZERO"] = "3.2.0";
  EventVersion2["THREE_FOUR_ZERO"] = "3.4.0";
  EventVersion2["THREE_TEN_ONE"] = "3.10.1";
  return EventVersion2;
}(EventVersion || {});
var EVENT_CATEGORY = "maps";
var buildEvent = function (eventName, eventType, eventVersion) {
  return {
    event_name: eventName,
    event_type: eventType,
    event_version: eventVersion,
    event_category: EVENT_CATEGORY
  };
};
var buildData = function (event, attributes) {
  return _object_spread_props(_object_spread({}, attributes), {
    event: event
  });
};
function useEgMapClickstream() {
  var clickstreamTrack = useEgClickstream();
  var track = function (data) {
    if (clickstreamTrack) {
      clickstreamTrack(data);
    }
  };
  var trackMapInit = function (mapType, selectionId) {
    var event = buildEvent("map.initiated", INTERACTION, "2.3.0" /* TWO_THREE_ZERO */);
    var attributes = {
      map_obj: {
        map_provider: mapType,
        map_selection_type: "product",
        map_selection_id: selectionId
      }
    };
    track(buildData(event, attributes));
  };
  var trackMapPresented = function (boundingBox, mapId, viewMode) {
    var event = buildEvent("map.presented", IMPRESSION, "2.4.0" /* TWO_FOUR_ZERO */);
    var attributes = {
      map_obj: {
        map_identifier: mapId,
        visible_bounding_box: boundingBox,
        view_mode: viewMode
      }
    };
    track(buildData(event, attributes));
  };
  var trackMapViewportMoved = function (boundingBox, movementType, zoomLevel) {
    var event = buildEvent("map_viewport.viewed", INTERACTION, "3.2.0" /* THREE_TWO_ZERO */);
    var attributes = {
      map_obj: {
        visible_bounding_box: boundingBox,
        movement_type: movementType,
        zoom_level: zoomLevel
      }
    };
    track(buildData(event, attributes));
  };
  var trackMapContentPresented = function (options) {
    var event = buildEvent("map_content.presented", IMPRESSION, "3.4.0" /* THREE_FOUR_ZERO */);
    var attributes = {
      map_obj: {
        tile_sets: options.tileSets,
        content_origin: options.origin
      },
      destination: {
        places_of_interest_count: options.placesOfInterestCount,
        restaurant_count: options.restaurantCount,
        grocery_count: options.groceryCount,
        transportation_count: options.transportationCount
      },
      map_product_detail: {
        product_cluster_count: options.productClusterCount,
        property_count: options.propertyCount
      }
    };
    track(buildData(event, attributes));
  };
  var trackMapPlaceSelected = function (selectionId, geometryType, qualifiers, selectionType) {
    var event = buildEvent("map_place.selected", INTERACTION, "3.10.1" /* THREE_TEN_ONE */);
    var attributes = {
      map_obj: {
        map_selection_id: selectionId,
        map_selection_type: selectionType,
        geometry_type_name: geometryType,
        qualifiers: qualifiers
      }
    };
    track(buildData(event, attributes));
  };
  var trackMapProductSelected = function (selectionId, selectionType) {
    var event = buildEvent("map_product.selected", INTERACTION, "1.0.1" /* ONE_ZERO_ONE */);
    var attributes = {
      map_obj: {
        map_selection_id: selectionId,
        map_selection_type: selectionType
      }
    };
    track(buildData(event, attributes));
  };
  var trackMapPropertySelected = trackMapProductSelected;
  var trackMapCustomPlaceAdded = function (searchType, searchDetail, featureId) {
    var event = buildEvent("map_place.added", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */);
    var attributes = {
      map_obj: {
        map_feature_id: featureId,
        map_search_type: searchType,
        map_search_detail: searchDetail
      }
    };
    track(buildData(event, attributes));
  };
  var trackMapCustomPlaceRemoved = function (searchType, searchDetail, featureId) {
    var event = buildEvent("map_place.removed", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */);
    var attributes = {
      map_obj: {
        map_feature_id: featureId,
        map_search_type: searchType,
        map_search_detail: searchDetail
      }
    };
    track(buildData(event, attributes));
  };
  var trackMapPlacesDialogOpened = function () {
    var event = buildEvent("map_dialog.opened", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */);
    track(buildData(event, {}));
  };
  var trackMapPlacesDialogClosed = function () {
    var event = buildEvent("map_dialog.closed", INTERACTION, "1.0.0" /* ONE_ZERO_ZERO */);
    track(buildData(event, {}));
  };
  var trackMapHidden = function () {
    var event = buildEvent("map.hidden", INTERACTION, "2.3.0" /* TWO_THREE_ZERO */);
    track(buildData(event, {}));
  };
  var clickTracker = useClickTracker();
  var trackMapFilterChanged = function (id, desc) {
    clickTracker(id, desc);
  };
  return {
    trackMapInit: trackMapInit,
    trackMapPresented: trackMapPresented,
    trackMapViewportMoved: trackMapViewportMoved,
    trackMapContentPresented: trackMapContentPresented,
    trackMapPlaceSelected: trackMapPlaceSelected,
    trackMapProductSelected: trackMapProductSelected,
    trackMapPropertySelected: trackMapPropertySelected,
    trackMapHidden: trackMapHidden,
    trackMapFilterChanged: trackMapFilterChanged,
    trackMapCustomPlaceAdded: trackMapCustomPlaceAdded,
    trackMapCustomPlaceRemoved: trackMapCustomPlaceRemoved,
    trackMapPlacesDialogOpened: trackMapPlacesDialogOpened,
    trackMapPlacesDialogClosed: trackMapPlacesDialogClosed
  };
}
// src/types.ts
var ContentOrigin = /* @__PURE__ */function (ContentOrigin2) {
  ContentOrigin2["USER"] = "user";
  ContentOrigin2["TILE"] = "tile";
  return ContentOrigin2;
}(ContentOrigin || {});
var CustomPlaceSearchType = /* @__PURE__ */function (CustomPlaceSearchType2) {
  CustomPlaceSearchType2["GAIA"] = "gaia";
  CustomPlaceSearchType2["GOOGLE"] = "google";
  return CustomPlaceSearchType2;
}(CustomPlaceSearchType || {});
var GeometryType = /* @__PURE__ */function (GeometryType2) {
  GeometryType2["POINT"] = "Point";
  return GeometryType2;
}(GeometryType || {});
var MovementType = /* @__PURE__ */function (MovementType2) {
  MovementType2["ZOOM_IN"] = "zoom_in";
  MovementType2["ZOOM_OUT"] = "zoom_out";
  MovementType2["PAN"] = "pan";
  return MovementType2;
}(MovementType || {});
var SelectionType = /* @__PURE__ */function (SelectionType2) {
  SelectionType2["CLUSTER"] = "cluster";
  SelectionType2["DESTINATION"] = "destination";
  SelectionType2["PRODUCT"] = "product";
  SelectionType2["PROPERTY"] = "property";
  return SelectionType2;
}(SelectionType || {});
// src/components/dynamic-map/dynamic-map.tsx
import { mergeAndConcat } from "merge-anything";
var trackMapViewportBoundChangedId = "trackMapViewportBoundChangedCb";
var trackMarkerSelectionId = "trackMarkerSelectionId";
var trackMapContentPresentedId = "trackMapContentPresentedId";
var trackHoverChangedId = "trackHoverChangedId";
var __DynamicMapFragment = gql(_templateObject());
var DynamicMap = function (param) {
  var children = param.children,
    data = param.data,
    className = param.className,
    beforeInit = param.beforeInit,
    onInit = param.onInit,
    initialViewport = param.initialViewport,
    initialMapConfig = param.initialMapConfig,
    supplementalFeatures = param.supplementalFeatures,
    onFeaturesPushed = param.onFeaturesPushed,
    egMapsConfig = param.egMapsConfig,
    selectedFeatureId = param.selectedFeatureId,
    viewMode = param.viewMode,
    _param_egDistancesEnabled = param.egDistancesEnabled,
    egDistancesEnabled = _param_egDistancesEnabled === void 0 ? false : _param_egDistancesEnabled,
    clientPadding = param.clientPadding,
    _param_height = param.height,
    height = _param_height === void 0 ? "100vh" : _param_height,
    _param_updateViewport = param.updateViewport,
    updateViewport = _param_updateViewport === void 0 ? true : _param_updateViewport;
  var _dynamicMapConfig_externalConfigEndpoint, _useGoogleMapsSdkVersion;
  var _ref = data || {},
    queryInitialViewport = _ref.initialViewport,
    center = _ref.center,
    zoom = _ref.zoom,
    bounds = _ref.bounds,
    computedBoundsOptions = _ref.computedBoundsOptions,
    config = _ref.config,
    markers = _ref.markers;
  var mapRef = React.useRef();
  var _React_useState = _sliced_to_array(React.useState(false), 2),
    initDone = _React_useState[0],
    setInitDone = _React_useState[1];
  var backupMapFragment = React.useRef();
  var trackClick = useClickTracker2();
  var _useEgMapClickstream = useEgMapClickstream(),
    trackMapInit = _useEgMapClickstream.trackMapInit,
    trackMapPresented = _useEgMapClickstream.trackMapPresented,
    trackMapViewportMoved = _useEgMapClickstream.trackMapViewportMoved,
    trackMapContentPresented = _useEgMapClickstream.trackMapContentPresented,
    trackMapPlaceSelected = _useEgMapClickstream.trackMapPlaceSelected,
    trackMapPropertySelected = _useEgMapClickstream.trackMapPropertySelected,
    trackMapProductSelected = _useEgMapClickstream.trackMapProductSelected,
    trackMapHidden = _useEgMapClickstream.trackMapHidden;
  var _useBexApi = useBexApi(),
    _useBexApi_context = _useBexApi.context,
    locale = _useBexApi_context.locale,
    currency = _useBexApi_context.currency;
  React.useEffect(function () {
    if (data) {
      backupMapFragment.current = data;
    }
  }, [data]);
  var dynamicMapConfig = React.useMemo(function () {
    var _backupMapFragment_current;
    return config || ((_backupMapFragment_current = backupMapFragment.current) === null || _backupMapFragment_current === void 0 ? void 0 : _backupMapFragment_current.config) || initialMapConfig;
  }, [initialMapConfig, config]);
  React.useEffect(function () {
    return trackMapHidden;
  }, []);
  React.useEffect(function () {
    if (dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.egdsMapProvider) {
      var provider = (dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.egdsMapProvider) === "MAPBOX" /* MAPBOX */ ? "mapbox" : "google-maps";
      trackMapInit(provider, selectedFeatureId);
    }
  }, [dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.egdsMapProvider]);
  var cfg = React.useMemo(function () {
    if (dynamicMapConfig) {
      var mapId = dynamicMapConfig.mapId,
        egdsMapProvider = dynamicMapConfig.egdsMapProvider,
        externalConfigEndpoint = dynamicMapConfig.externalConfigEndpoint;
      var configs = [egMapsConfig || {}];
      configs.push(className ? {
        additionalCssClass: className
      } : {});
      configs.push(locale ? {
        locale: locale
      } : {});
      configs.push(currency ? {
        iso4217CurrencyCode: currency
      } : {});
      var externalConfEndPoint = externalConfigEndpoint === null || externalConfigEndpoint === void 0 ? void 0 : externalConfigEndpoint.value;
      configs.push(externalConfEndPoint ? {
        externalConfigEndpoint: externalConfEndPoint
      } : {});
      if (mapId) {
        switch (egdsMapProvider) {
          case "MAPBOX" /* MAPBOX */:
            configs.push({
              mapbox: {
                mapboxAddConf: {
                  style: mapId
                }
              }
            });
            break;
          case "GOOGLE" /* GOOGLE */:
          default:
            configs.push({
              googleMaps: {
                gmapsAddConfig: {
                  mapId: mapId
                }
              }
            });
            break;
        }
      }
      return mergeAndConcat.apply(void 0, [{}].concat(_to_consumable_array(configs)));
    }
  }, [dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : (_dynamicMapConfig_externalConfigEndpoint = dynamicMapConfig.externalConfigEndpoint) === null || _dynamicMapConfig_externalConfigEndpoint === void 0 ? void 0 : _dynamicMapConfig_externalConfigEndpoint.value, dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.mapId, dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.egdsMapProvider, locale, currency, egMapsConfig]);
  var accessToken = dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.accessToken;
  var identifyMapType = function () {
    switch (dynamicMapConfig === null || dynamicMapConfig === void 0 ? void 0 : dynamicMapConfig.egdsMapProvider) {
      case "MAPBOX" /* MAPBOX */:
        return EGDSEGMapsType.MAPBOX;
      case "GOOGLE" /* GOOGLE */:
      default:
        return EGDSEGMapsType.GOOGLE;
    }
  };
  var googleMapsSDKVersion = (_useGoogleMapsSdkVersion = useGoogleMapsSdkVersion()) === null || _useGoogleMapsSdkVersion === void 0 ? void 0 : _useGoogleMapsSdkVersion.version;
  var identifyMapTypeVersion = function (mapType2) {
    if (mapType2 === EGDSEGMapsType.GOOGLE) {
      return googleMapsSDKVersion;
    }
    return void 0;
  };
  var mapType = identifyMapType();
  var mapTypeVersion = identifyMapTypeVersion(mapType);
  var features = React.useMemo(function () {
    return _to_consumable_array(convertMarkers(markers === null || markers === void 0 ? void 0 : markers.map(function (m) {
      return m;
    }))).concat(_to_consumable_array(supplementalFeatures || []));
  }, [markers, supplementalFeatures]);
  var featureCoordinates = React.useMemo(function () {
    return features === null || features === void 0 ? void 0 : features.map(function (f) {
      return [f.lat, f.lng];
    });
  }, [features]);
  var computeBoundsViewport = function (b) {
    return {
      sw: [b === null || b === void 0 ? void 0 : b.southwest.latitude, b === null || b === void 0 ? void 0 : b.southwest.longitude],
      ne: [b === null || b === void 0 ? void 0 : b.northeast.latitude, b === null || b === void 0 ? void 0 : b.northeast.longitude]
    };
  };
  var computeCenterAndZoomViewport = function (c, z) {
    return {
      center: [c === null || c === void 0 ? void 0 : c.latitude, c === null || c === void 0 ? void 0 : c.longitude],
      zoom: z
    };
  };
  var computeBoundsComputedViewport = function (coordinates, options) {
    return {
      useBoundsComputation: true,
      options: {
        gaiaId: (options === null || options === void 0 ? void 0 : options.gaiaId) && !Number.isNaN(Number(options === null || options === void 0 ? void 0 : options.gaiaId)) ? Number(options === null || options === void 0 ? void 0 : options.gaiaId) : void 0,
        lowerQuantile: options === null || options === void 0 ? void 0 : options.lowerQuantile,
        upperQuantile: options === null || options === void 0 ? void 0 : options.upperQuantile,
        marginMultiplier: options === null || options === void 0 ? void 0 : options.marginMultiplier,
        minMargin: options === null || options === void 0 ? void 0 : options.minMargin,
        minimumPins: options === null || options === void 0 ? void 0 : options.minimumPins,
        interpolationRatio: options === null || options === void 0 ? void 0 : options.interpolationRatio
      },
      coordinates: options.coordinates.length > 0 ? options.coordinates.map(function (c) {
        return [c.latitude, c.longitude];
      }) : coordinates
    };
  };
  React.useEffect(function () {
    var map = mapRef.current;
    if (updateViewport && initDone && map) {
      switch (queryInitialViewport) {
        case "BOUNDS" /* BOUNDS */:
          if (bounds) {
            var _computeBoundsViewport = computeBoundsViewport(bounds),
              sw = _computeBoundsViewport.sw,
              ne = _computeBoundsViewport.ne;
            map.fitBounds(sw, ne, void 0, clientPadding);
          }
          break;
        case "CENTER_AND_ZOOM" /* CENTER_AND_ZOOM */:
          if (center !== null && zoom !== null) {
            var _computeCenterAndZoomViewport = computeCenterAndZoomViewport(center, zoom),
              c = _computeCenterAndZoomViewport.center,
              z = _computeCenterAndZoomViewport.zoom;
            map.centerAndZoomMap(c, z, clientPadding);
          }
          break;
        case "COMPUTED_BOUNDS" /* COMPUTED_BOUNDS */:
          if (computedBoundsOptions) {
            var _computeBoundsComputedViewport = computeBoundsComputedViewport(featureCoordinates, computedBoundsOptions),
              useBoundsComputation = _computeBoundsComputedViewport.useBoundsComputation,
              options = _computeBoundsComputedViewport.options,
              coordinates = _computeBoundsComputedViewport.coordinates;
            map.boundsContaining(coordinates, useBoundsComputation, options).then(function (boundsWithCenter) {
              var sw = boundsWithCenter.sw,
                ne = boundsWithCenter.ne;
              map.fitBounds(sw, ne, void 0, clientPadding);
            });
          }
          break;
        case "FIT_MARKERS" /* FIT_MARKERS */:
          if ((featureCoordinates === null || featureCoordinates === void 0 ? void 0 : featureCoordinates.length) > 0) {
            map.fitLatLongs(featureCoordinates, void 0, clientPadding);
          }
          break;
        default:
          if (initialViewport) {
            map.centerAndZoomMap(initialViewport.center, initialViewport.zoom, clientPadding);
          }
          break;
      }
    }
  }, [initDone, queryInitialViewport, center, zoom, bounds, computedBoundsOptions, featureCoordinates, updateViewport, clientPadding]);
  var initialViewportObject = React.useMemo(function () {
    switch (queryInitialViewport) {
      case "BOUNDS" /* BOUNDS */:
        return bounds ? computeBoundsViewport(bounds) : void 0;
      case "CENTER_AND_ZOOM" /* CENTER_AND_ZOOM */:
        return center && zoom !== null ? computeCenterAndZoomViewport(center, zoom) : void 0;
      case "COMPUTED_BOUNDS" /* COMPUTED_BOUNDS */:
        return computedBoundsOptions ? computeBoundsComputedViewport(featureCoordinates, computedBoundsOptions) : void 0;
      case "FIT_MARKERS" /* FIT_MARKERS */:
        return featureCoordinates;
      default:
        return initialViewport;
    }
  }, [initialViewport, queryInitialViewport, center, zoom, bounds, computedBoundsOptions, featureCoordinates]);
  var trackMapViewportBoundChangedCb = React.useCallback(function (event) {
    var boundChangeMovementMapping = {
      zoomIn: "zoom_in" /* ZOOM_IN */,
      zoomOut: "zoom_out" /* ZOOM_OUT */,
      drag: "pan" /* PAN */,
      zoomInKeyboard: "zoom_in" /* ZOOM_IN */,
      zoomOutKeyboard: "zoom_out" /* ZOOM_OUT */,
      pitch: "pan" /* PAN */,
      rotate: "pan" /* PAN */,
      touch: "pan" /* PAN */,
      moveKeyboard: "pan" /* PAN */,
      clusterExtent: "zoom_in" /* ZOOM_IN */
    };
    var boundsChangeType = event === null || event === void 0 ? void 0 : event.originalEvent;
    var movementType = boundChangeMovementMapping[boundsChangeType];
    if (movementType !== void 0) {
      trackMapViewportMoved(egBoundsToString(event.bounds), movementType, event.zoom);
    }
  }, [trackMapViewportMoved]);
  var trackMarkerClick = React.useCallback(function (feature) {
    if (feature) {
      var type = feature.type,
        _feature_id = feature.id,
        id = _feature_id === void 0 ? null : _feature_id;
      if (type && id !== null) {
        switch (type) {
          case "place":
            trackMapPlaceSelected(id.toString(), "Point" /* POINT */, feature.qualifiers || [], "destination" /* DESTINATION */);
            break;
          case "product":
            trackMapPropertySelected(id.toString(), "product" /* PRODUCT */);
            break;
          case "property":
            trackMapPropertySelected(id.toString(), "property" /* PROPERTY */);
            break;
          case "cluster":
            trackMapPlaceSelected(id.toString(), "Point" /* POINT */, [], "cluster" /* CLUSTER */);
            break;
          default:
            break;
        }
      }
    }
  }, [trackMapPlaceSelected, trackMapPropertySelected, trackMapProductSelected]);
  var tilesContentLoadedCallback = React.useCallback(function () {
    setTimeout(function () {
      var options = getContentPresentedOptions(mapRef.current, "tile" /* TILE */);
      trackMapContentPresented(options);
    }, CONTENT_PRESENTED_DELAY);
  }, [trackMapContentPresented]);
  var trackMarkerSelectionCb = React.useCallback(function (event) {
    if (event.action === "select") {
      trackMarkerClick(event.feature);
    }
  }, [trackMarkerClick]);
  React.useEffect(function () {
    if (mapRef.current) {
      mapRef.current.addBoundChangeListener(trackMapViewportBoundChangedCb, trackMapViewportBoundChangedId);
    }
  }, [trackMapViewportBoundChangedCb]);
  React.useEffect(function () {
    if (mapRef.current) {
      mapRef.current.addSelectionChangeListener(trackMarkerSelectionCb, trackMarkerSelectionId);
    }
  }, [trackMarkerSelectionCb]);
  React.useEffect(function () {
    if (mapRef.current) {
      mapRef.current.addTilesContentLoadedListener(tilesContentLoadedCallback, trackMapContentPresentedId);
    }
  }, [tilesContentLoadedCallback]);
  var trackHoverChangedCb = React.useCallback(function (event) {
    if (mapRef.current) {
      var _event_feature_qualifiers;
      if ((_event_feature_qualifiers = event.feature.qualifiers) === null || _event_feature_qualifiers === void 0 ? void 0 : _event_feature_qualifiers.includes(EGDSEGMapsQualifier2.MINIPIN)) {
        var _event_feature_qualifiers1, _event_feature_qualifiers2;
        if (event.action === "mouseEnter" && !((_event_feature_qualifiers1 = event.feature.qualifiers) === null || _event_feature_qualifiers1 === void 0 ? void 0 : _event_feature_qualifiers1.includes("over"))) {
          var _mapRef_current;
          (_mapRef_current = mapRef.current) === null || _mapRef_current === void 0 ? void 0 : _mapRef_current.addQualifierToFeature(event.feature.id, event.feature.type, "over");
        }
        if (event.action === "mouseLeave" && ((_event_feature_qualifiers2 = event.feature.qualifiers) === null || _event_feature_qualifiers2 === void 0 ? void 0 : _event_feature_qualifiers2.includes("over"))) {
          var _mapRef_current1;
          (_mapRef_current1 = mapRef.current) === null || _mapRef_current1 === void 0 ? void 0 : _mapRef_current1.removeQualifierFromFeature(event.feature.id, event.feature.type, "over");
        }
      }
    }
  }, []);
  React.useEffect(function () {
    if (mapRef.current) {
      mapRef.current.addHoverChangeListener(trackHoverChangedCb, trackHoverChangedId);
    }
  }, [trackHoverChangedCb]);
  var internalBeforeInit = React.useCallback(function (map) {
    mapRef.current = map;
    map.addBoundChangeListener(trackMapViewportBoundChangedCb, trackMapViewportBoundChangedId);
    map.addSelectionChangeListener(trackMarkerSelectionCb, trackMarkerSelectionId);
    map.addTilesContentLoadedListener(tilesContentLoadedCallback, trackMapContentPresentedId);
    map.addHoverChangeListener(trackHoverChangedCb, trackHoverChangedId);
    if (beforeInit) {
      beforeInit(map);
    }
  }, []);
  var onInitInternal = React.useCallback(function (map) {
    setInitDone(true);
    if (map) {
      var mapId = "";
      switch (mapType) {
        case EGDSEGMapsType.MAPBOX:
          mapId = map.readConfigParam("mapbox,mapboxAddConf,style");
          break;
        case EGDSEGMapsType.GOOGLE:
        default:
          mapId = map.readConfigParam("googleMaps,gmapsAddConfig,mapId");
          break;
      }
      var bbox = map.getBounds();
      if (bbox) {
        var bboxString = boundingBoxToString(bbox.sw, bbox.ne);
        trackMapPresented(bboxString, mapId, viewMode);
      }
    }
    if (onInit) {
      onInit(map);
    }
  }, [onInit, trackMapPresented, viewMode, mapType]);
  var onFeaturesPushedInternal = React.useCallback(function (map, b) {
    if (b) {
      setTimeout(function () {
        var options = getContentPresentedOptions(map, "user" /* USER */);
        trackMapContentPresented(options);
      }, CONTENT_PRESENTED_DELAY);
      if (onFeaturesPushed) {
        onFeaturesPushed(map, b);
      }
    }
  }, [onFeaturesPushed, trackMapContentPresented]);
  if (!dynamicMapConfig && !initDone) {
    return /* @__PURE__ */React.createElement("div", {
      style: {
        height: height
      }
    }, /* @__PURE__ */React.createElement(EGDSLayoutPosition, {
      type: "relative",
      position: {
        top: "center",
        left: "center"
      }
    }, /* @__PURE__ */React.createElement(EGDSPageLoader, {
      visible: true
    })));
  }
  return /* @__PURE__ */React.createElement(EGDSEGMaps, {
    accessToken: accessToken,
    mapType: mapType,
    initialViewport: initialViewportObject,
    beforeInit: internalBeforeInit,
    onInit: onInitInternal,
    height: height,
    mapConfig: cfg,
    mapTypeVersion: mapTypeVersion,
    features: features,
    onFeaturesPushed: onFeaturesPushedInternal,
    egDistancesEnabled: egDistancesEnabled,
    clientPadding: clientPadding
  }, children);
};
DynamicMap.displayName = "DynamicMap";
DynamicMap.fragment = __DynamicMapFragment;
// src/components/dynamic-map/utils.ts
import { EGDSEGMapsQualifier as EGDSEGMapsQualifier3 } from "@egds/react-maps";
var isProductType = function (markerType) {
  return markerType === "property" || markerType === "product";
};
var filterFeatureObject = function (f) {
  return true;
};
var findPinnedFeature = function (mapRef) {
  var _mapRef_listFeatures_filter;
  return (_mapRef_listFeatures_filter = mapRef.listFeatures(function (f) {
    var _f_qualifiers;
    return (_f_qualifiers = f.qualifiers) === null || _f_qualifiers === void 0 ? void 0 : _f_qualifiers.includes(EGDSEGMapsQualifier3.PINNED);
  }).filter(filterFeatureObject)) === null || _mapRef_listFeatures_filter === void 0 ? void 0 : _mapRef_listFeatures_filter[0];
};
var findProductObject = function (mapRef, id) {
  var _mapRef_listFeatures_filter;
  return (_mapRef_listFeatures_filter = mapRef.listFeatures(function (f) {
    return isProductType(f.type) && f.id === id;
  }).filter(filterFeatureObject)) === null || _mapRef_listFeatures_filter === void 0 ? void 0 : _mapRef_listFeatures_filter[0];
};
// src/components/map-card-content/map-card-content.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
var MapCardSize = /* @__PURE__ */function (MapCardSize2) {
  MapCardSize2[MapCardSize2["STANDARD"] = 0] = "STANDARD";
  MapCardSize2[MapCardSize2["COMPACT"] = 1] = "COMPACT";
  return MapCardSize2;
}(MapCardSize || {});
var __MapCardContentFragment = gql2(_templateObject1());
var MapCardContent = function (props) {
  var data = props.data,
    size = props.size,
    imageRatio = props.imageRatio;
  if (!data || !data.title) {
    return null;
  }
  var image = data.image,
    subTitle = data.subTitle,
    title = data.title,
    id = data.id,
    description = data.description;
  var ratio = imageRatio || size === 1 /* COMPACT */ ? EGDSFigureAspectRatioType.R3_4 : EGDSFigureAspectRatioType.R4_3;
  var mapCardMinWidth = size === 1 /* COMPACT */ ? 296 : 552;
  var mapCardMinHeight = 63;
  return /* @__PURE__ */React2.createElement(EGDSCard, null, /* @__PURE__ */React2.createElement("div", {
    "data-testid": "map-card-".concat(id)
  }), /* @__PURE__ */React2.createElement(EGDSLayoutGrid, {
    alignItems: "start",
    columns: 4,
    style: {
      minHeight: mapCardMinHeight,
      minWidth: mapCardMinWidth
    }
  }, image ? /* @__PURE__ */React2.createElement(EGDSLayoutGridItem, {
    colSpan: 1
  }, /* @__PURE__ */React2.createElement(EGDSFigure, {
    ratio: ratio,
    roundcorner: ["startstart"]
  }, /* @__PURE__ */React2.createElement(EGDSImage, {
    src: image.url,
    alt: image.description,
    placeholderImage: true
  }))) : null, /* @__PURE__ */React2.createElement(EGDSLayoutGridItem, {
    colSpan: image ? 3 : 4
  }, /* @__PURE__ */React2.createElement(EGDSLayoutFlex, {
    direction: "column",
    blockSize: "full_size",
    justifyContent: "space-between"
  }, /* @__PURE__ */React2.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React2.createElement(EGDSCardContentSection, null, /* @__PURE__ */React2.createElement(EGDSHeading, null, title), description ? /* @__PURE__ */React2.createElement(EGDSText, {
    size: 200,
    spacing: "one"
  }, description) : null)), /* @__PURE__ */React2.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React2.createElement(EGDSCardContentSection, null, subTitle ? /* @__PURE__ */React2.createElement(EGDSText, {
    size: 200
  }, subTitle) : null))))));
};
MapCardContent.fragment = __MapCardContentFragment;
MapCardContent.displayName = "MapCardContent";
export { ContentOrigin, CustomPlaceSearchType, DynamicMap, EventVersion, GeometryType, IMPRESSION, INTERACTION, MapCardContent, MapCardSize, MovementType, SelectionType, buildData, buildEvent, convertMarkers, filterFeatureObject, findPinnedFeature, findProductObject, isProductType, useEgMapClickstream }; /* istanbul ignore file -- @preserve */